var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"worder-top"},[_c('div',{staticClass:"worder-title",on:{"click":_vm.handleCancel}},[_c('a-icon',{staticClass:"icon",attrs:{"type":"left"}}),_vm._v("返回\n  ")],1)])}
var staticRenderFns = []

export { render, staticRenderFns }